import type { FC } from 'react';
import React, { useState } from 'react';

import { Box, Collapse, Typography } from '@mui/material';

import { ArrowDownSmallIcon } from '@setup/svg-icons/svg-icons';

import { MuiTextAccordionContainer } from './MuiTextAccordion.style';

type Props = {
  title: string;
  text?: string;
  textComponent?: React.ReactNode;
};

export const MuiTextAccordion: FC<Props> = ({ title, text, textComponent }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <MuiTextAccordionContainer onClick={() => setIsOpen((prev) => !prev)}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          cursor: 'pointer',
        }}
      >
        <Typography variant="small">{title}</Typography>
        <Box
          sx={{
            width: '20px',
            height: '20px',
            marginRight: '5px',
            display: 'flex',
            alignItems: 'center',
            svg: {
              transform: isOpen ? 'rotate(180deg)' : '',
              transition: '0.3s',
            },
          }}
        >
          <ArrowDownSmallIcon />
        </Box>
      </Box>
      <Collapse unmountOnExit in={isOpen}>
        <Box sx={{ pr: '25px', pt: '10px' }}>
          {textComponent ? (
            textComponent
          ) : (
            <Typography variant="small" sx={(theme) => ({ color: theme.palette.case.neutral.n700 })}>
              {text}
            </Typography>
          )}
        </Box>
      </Collapse>
    </MuiTextAccordionContainer>
  );
};
